module.exports = __webpack_public_path__ + "img/global.f3790e63.jpg";